<template>
  <div class="reactive-rover">
    <reactive-rover-card />
  </div>
</template>

<script>
import ReactiveRoverCard from '../cards/ReactiveRoverCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'reactive-rover',
  components: {
    ReactiveRoverCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services/group-class/reactive-rover',
      ogTitle: 'Reactive Rover - Rewarding Dog Training',
      ogDescription: 'In this 6 week class, you will learn how to teach your dog skills to better handle the unexpected world around them, leading to decreased anxiety and reactivity.',
    })
  },
}
</script>

<style lang="scss">
.reactive-rover {
  width: 100%;
}
</style>
